import React from "react";
import { motion } from "framer-motion";

/**
 * Reusable inner-page hero — cinematic dark image band with white type.
 */
export default function PageHero({ eyebrow, title, italic, subtitle, image }) {
  return (
    <section className="relative pt-40 md:pt-48 pb-20 md:pb-28 overflow-hidden bg-[#0A0A0A]">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-55" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-[#0A0A0A]/55 to-[#0A0A0A]/85" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-3 text-[#E8DAB8]"
          >
            <span className="block w-8 h-px bg-[#C9A86A]" />
            <span className="text-[11px] uppercase tracking-[0.3em]">{eyebrow}</span>
          </motion.div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 font-display-bold text-5xl md:text-6xl lg:text-7xl tracking-tighter text-white max-w-4xl"
        >
          {title}{" "}
          {italic && (
            <span className="font-serif-italic font-light text-[#E8DAB8]">{italic}</span>
          )}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-7 text-white/80 max-w-2xl text-base md:text-lg leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
